import axios from 'axios'

type PartResultUploadProps = {
  url: string
  zipBlob: Uint8Array
}

export async function partResultUpload({
  url,
  zipBlob,
}: PartResultUploadProps) {
  await axios.put(url, zipBlob, {
    headers: {
      'Content-Type': 'application/zip'
    }
  })
}
